/**
 * Builds the per-panel "Ask AI" handler for the ⋯ menu. A host can veto a
 * panel type (`canAskAI` returns false) and the menu then hides the item,
 * because PanelMoreMenu only shows Ask AI when it is given a handler.
 */
export function askAIFor(
  canAskAI: ((componentType: string) => boolean) | undefined,
  ask: (panelId: string, componentType: string) => void,
) {
  return (panelId: string, componentType: string): (() => void) | undefined =>
    canAskAI && !canAskAI(componentType) ? undefined : () => ask(panelId, componentType)
}
